// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__c-tAY","noInteraction":"EventWrapper_noInteraction__2sXI2","pointerPassthrough":"EventWrapper_pointerPassthrough__1e3Nc"};